import React, { useEffect, useRef } from 'react';
import css from './MediaUpload.module.css';
import { FormattedMessage } from 'react-intl';
import Button, { SecondaryButton } from '../Button/Button';
import { PhotoTag } from '../../util/enums';

const MenuContainer = ({
  form,
  file,
  fieldName,
  index,
  isMenuOpen,
  handleTagImage,
  handleDeleteFile,
  toggleMenu,
  setMenuVisibility,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisibility(prev => ({ ...prev, [index]: false }));
      }
    };

    if (isMenuOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen, index, setMenuVisibility]);

  return (
    <>
      <div className={css.menuContainer} ref={menuRef}>
        <SecondaryButton
          type="button"
          className={css.threeDotButton}
          onClick={() => toggleMenu(index)}
        >
          &#8942;
        </SecondaryButton>
        {isMenuOpen && (
          <div className={css.menu}>
            <Button
              type="button"
              className={css.menuOption}
              onClick={() => handleTagImage(index, PhotoTag.PROFILE)}
            >
              <FormattedMessage id="MediaUpload.profileImage" />
            </Button>
            <Button
              type="button"
              className={css.menuOption}
              onClick={() => handleTagImage(index, PhotoTag.TRADING_CARD)}
            >
              <FormattedMessage id="MediaUpload.tradingCardImage" />
            </Button>
            <Button
              type="button"
              className={`${css.menuOption} ${css.deleteOption}`}
              onClick={() => {
                handleDeleteFile({ form, file, fieldName });
                setMenuVisibility(prev => ({ ...prev, [index]: false })); // Close the menu after deletion
                form.change('profileImageIndex', null);
                form.change('tradingCardImageIndex', null);
              }}
            >
              <FormattedMessage id="MediaUpload.delete" />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default MenuContainer;
